/**
 * Offline Detection Utility
 * 
 * Monitors network connectivity and triggers sync when connection is restored
 */

import { useSyncStore } from '../stores/syncStore';

let isInitialized = false;

/**
 * Initialize offline detection listeners
 */
export function initOfflineDetection() {
  if (isInitialized) {
    return;
  }
  
  
  // Listen for online event
  window.addEventListener('online', handleOnline);
  
  // Listen for offline event
  window.addEventListener('offline', handleOffline);
  
  // Set initial status
  if (!navigator.onLine) {
    useSyncStore.getState().setStatus('offline');
  }
  
  isInitialized = true;
}

/**
 * Clean up offline detection listeners
 */
export function cleanupOfflineDetection() {
  if (!isInitialized) {
    return;
  }
  
  window.removeEventListener('online', handleOnline);
  window.removeEventListener('offline', handleOffline);
  
  isInitialized = false;
}

/**
 * Handle online event — drena fila offline ao reconectar
 */
function handleOnline() {
  const syncStore = useSyncStore.getState();

  // Se há operações na fila offline, drenar
  import('../services/offlineQueue').then(({ drainOfflineQueue, getQueueCount }) => {
    getQueueCount().then(count => {
      if (count > 0) {
        syncStore.setStatus('syncing');
        drainOfflineQueue().catch(err => {
          import('../utils/logger').then(({ logger }) => {
            logger.error('offlineDetection', 'Erro ao drenar fila offline:', err);
          });
        });
      } else {
        syncStore.setStatus('idle');
        // Drenar fila legacy do syncStore (se houver)
        syncStore.processQueue();
      }
    }).catch(() => {
      // IndexedDB indisponível — fallback para comportamento anterior
      syncStore.setStatus('idle');
      syncStore.processQueue();
    });
  }).catch(() => {
    // Import falhou — fallback para comportamento anterior
    syncStore.setStatus('idle');
    syncStore.processQueue();
  });
}

/**
 * Handle offline event — atualiza status com contagem da fila
 */
function handleOffline() {
  const syncStore = useSyncStore.getState();

  // Verificar se há operações na fila para mostrar 'queued' em vez de 'offline'
  import('../services/offlineQueue').then(({ getQueueCount }) => {
    getQueueCount().then(count => {
      syncStore.setStatus(count > 0 ? 'queued' : 'offline');
      useSyncStore.setState({ queuedCount: count });
    }).catch(() => {
      syncStore.setStatus('offline');
    });
  }).catch(() => {
    syncStore.setStatus('offline');
  });
}

/**
 * Check if currently online
 */
export function isOnline(): boolean {
  return navigator.onLine;
}
